import React, { Fragment, useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Content, ReadOnlyForm } from '../../../fgs';
import { ProfileForm } from "./components";
import { readOnlyRowsSetup } from "./utils";
import { createReadOnlyForm } from "../../forms/createReadOnlyForm";
import { UserResourcesPage } from "./subPages";
import { Visible, canView, not } from "../../../fgs/helpers/Authorization";

// services
import { getUser, updateUser } from '../../../services/api';
import { userRoleMapper } from '../../../services/selectOptions';
import RequestContext from '../../../fgs/context/RequestContext';

const PROFILE_TAB = 'PROFILE';
const RESOURCES_TAB = 'RESOURCES';

const FullComponent = (props) => {
  const initActiveTab = () => {
    return location.hash === '#resources' ? RESOURCES_TAB : PROFILE_TAB;
  };

  const { Profile } = props;
  const [activeTab, setActiveTab] = useState(initActiveTab());

  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <Fragment>
      <Nav tabs>
        <NavItem>
          <NavLink
            href="#profile"
            active={activeTab === PROFILE_TAB}
            onClick={() => toggle(PROFILE_TAB)}>
            Perfil
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            href="#resources"
            active={activeTab === RESOURCES_TAB}
            onClick={() => toggle(RESOURCES_TAB)}>
            Recursos
          </NavLink>
        </NavItem>
      </Nav>

      <TabContent activeTab={activeTab}>
        <TabPane tabId={PROFILE_TAB}>
          {activeTab === PROFILE_TAB
            ? <Profile />
            : null}
        </TabPane>

        <TabPane tabId={RESOURCES_TAB}>
          {activeTab === RESOURCES_TAB ? <UserResourcesPage /> : null}
        </TabPane>
      </TabContent>
    </Fragment>
  );
};

export const UserProfilePage = () => {
  const { id } = useParams();
  const context = useContext(RequestContext);
  const loggedUser = context?.loggedUser;
  const history = useHistory();
  const [showReadOnlyForm, setShowReadOnlyForm] = useState(true);
  const [form, setForm] = useState({});
  

  const fetchUser = async (id) => {
    await getUser(id).then((response) => {
      const attributes = response.data.data.attributes;
      attributes.roleLabel = userRoleMapper[attributes.role];

      setForm(response.data.data.attributes);
    });
  };

  useEffect(() => {
    fetchUser(id);
  }, []);

  const onSave = (saveForm) => {
    updateUser(id, saveForm).then(() => {
      if (loggedUser?.role === 'admin') {
        history.push('/dashboard/users');
      }
    });
  };

  const toggleForms = () => {
    setShowReadOnlyForm(!showReadOnlyForm);
  };

  const formControls = [
    { title: 'Editar', props: { color: 'primary', onClick: toggleForms } },
    { title: 'Voltar', props: { color: 'secondary', onClick: () => history.push('dashboard/users') } }
  ];

  const Profile = () => {
    return (
      <Fragment>
        <h5>Dados gerais</h5>
        <hr />
        { !showReadOnlyForm && <ProfileForm onSave={onSave} form={form} setShowForm={toggleForms} />}
        {
          showReadOnlyForm &&
          <ReadOnlyForm form={createReadOnlyForm(form, readOnlyRowsSetup)} formControls={formControls} />
        }
      </Fragment>
    );
  };

  return (
    <Content id="nav-item-page">
      <Visible when={canView('UserResourcesPage')}>
        <FullComponent Profile={Profile} />
      </Visible>

      <Visible when={not(canView('UserResourcesPage'))}>
        <Profile />
      </Visible>
    </Content>
  );
};